import React from 'react'
import { Text, View, Image, Dimensions, TouchableOpacity, FlatList } from 'react-native'
import * as Progress from 'react-native-progress'
import styles from './MyAdvanceStyles'
import theme from '../../../theme'
import { avatarPlaceholder } from '../customUtils/Constants'
import { colorFilled, colorUnfilled } from '../../../themeConstants'
import { ScrollView } from 'react-native-gesture-handler'
import { FlashList } from '@shopify/flash-list'
import { AdvanceTeamModel, AdvanceTeamRegion } from './models/MyAdvanceModel'
// import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { DotsNavigation } from '../navigation/stacks/NavigationStack'
import { useBreakpoint, useIsMobile } from '@/redux/zustand/useDimensionStore'
import { useNavigation } from '@/hooks/useWebNavigation'

const { width } = Dimensions.get('window')

export const MyTeamAdvanceScreen = ({ route }) => {
    const regions: AdvanceTeamRegion[] = route?.params?.regions
    const updateDate: string = route?.params?.updateDate
    const navigation = useNavigation()

    if (!regions || regions?.length === 0) {
        return (
            <View style={{ flex: 1, justifyContent: 'center' }}>
                <View style={styles.spacer2}></View>
                <Image source={require('../../../assets/advance/noDataEvaluations.png')} style={styles.noDataEvaluations} />

                <Text style={[styles.noDataText, { marginVertical: 16 }]}>No hay regiones para ver</Text>
            </View>
        )
    }
    const onClickRegion = (region: AdvanceTeamRegion) => {
        const params = {
            regions: [region],
            updateDate: updateDate,
        }
        console.log('CLICK REGION NAVEGAR ===>, ', params)
        navigation.navigate('MyTeamAdvanceScreen', params)
    }
    const onClickTeam = (team: AdvanceTeamModel) => {
        let memberID = team._id
        let params = { id: memberID }

        console.log('CLICK TEAM NAVEGAR ===>, ', params)
        navigation.navigate('MyTeamScreen', params)
    }
    const isMobile = useIsMobile()
    const bp = useBreakpoint()
    const columns = bp === 'sm' ? 1 : bp === 'md' ? 2 : 3
    return (
        <View
            style={{
                flex: 1,
                backgroundColor: 'white',
                flexDirection: 'column',
                width: '100%',
            }}
        >
            <View
                style={[
                    {
                        flex: 1,
                        backgroundColor: 'white',
                        flexDirection: 'column',
                        width: '100%',
                    },
                    !isMobile && { maxWidth: 1024, alignSelf: 'center', flex: undefined, paddingHorizontal: 12 },
                ]}
            >
                <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={!isMobile && { paddingHorizontal: 0 }}>
                    {regions.length > 1 ? (
                        <View style={{ flex: 1 }}>
                            <FlatList
                                key={`columns-${columns}`}
                                data={regions}
                                horizontal={false}
                                keyExtractor={(item) => item._id.toString()}
                                numColumns={columns}
                                showsHorizontalScrollIndicator={false}
                                showsVerticalScrollIndicator={false}
                                ItemSeparatorComponent={() => <View style={{ height: 12 }} />}
                                columnWrapperStyle={columns > 1 ? { justifyContent: 'flex-start', columnGap: 12 } : undefined}
                                renderItem={({ item: region }) => (
                                    <RegionItem region={region} onClickRegion={onClickRegion} card={true} numColumns={columns} />
                                )}
                            />
                        </View>
                    ) : (
                        <View>
                            <RegionItemSingle region={regions[0]} onClickRegion={() => {}} card={false} />
                            <FlatList
                                key={`columns-${columns}`}
                                data={regions[0].team}
                                horizontal={false}
                                keyExtractor={(item) => item._id.toString()}
                                numColumns={columns}
                                showsHorizontalScrollIndicator={false}
                                showsVerticalScrollIndicator={false}
                                contentContainerStyle={{ paddingHorizontal: 12 }}
                                ItemSeparatorComponent={() => <View style={{ height: 16 }} />}
                                columnWrapperStyle={columns > 1 ? { justifyContent: 'flex-start', columnGap: 12 } : undefined}
                                renderItem={({ item: team }) => <TeamItem team={team} onClickTeam={onClickTeam} numColumns={columns} />}
                            />
                        </View>
                    )}

                    <Text style={[styles.infoText, styles.alignCenter]}>{'Última actualización: ' + updateDate}</Text>
                    <View style={styles.spacer2}></View>
                </ScrollView>
            </View>
        </View>
    )
}

export const RegionItem = ({
    region,
    onClickRegion,
    card,
    numColumns,
}: {
    region: AdvanceTeamRegion
    onClickRegion: (region: AdvanceTeamRegion) => void
    card: boolean
    numColumns: number
}) => {
    const isMobile = useIsMobile()
    const maxWidth = numColumns > 2 ? '32%' : '50%'
    const progressSize = 92
    return (
        <TouchableOpacity
            style={[
                styles.containerRowCard,
                { pointerEvents: !card ? 'none' : null },
                !isMobile && { maxWidth: maxWidth },
                isMobile && { width: '94%' },
            ]}
            onPress={() => onClickRegion(region)}
        >
            <View style={[{ marginHorizontal: 12, maxWidth: progressSize }]}>
                <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                    <Progress.Circle
                        size={progressSize}
                        progress={0.3}
                        showsText={false}
                        textStyle={styles.percentage}
                        thickness={isMobile ? 12 : 6}
                        color={theme.colors.colorPrimary}
                        unfilledColor={theme.colors.disabled}
                        borderWidth={0}
                        borderColor={theme.colors.colorSecondary}
                        strokeCap='round'
                        style={{ alignSelf: 'center' }}
                    />
                    {region.ranking && <Text style={[styles.percentageBis, styles.alignCenter, { position: 'absolute' }]}>{region.ranking}°</Text>}
                </View>
                {region.name && <View style={styles.spacer2}></View>}
                {region.name && (
                    <Text style={[styles.section, styles.marginHorizontal, styles.alignCenter, !isMobile && { fontSize: 16 }]}>
                        {region.name.toUpperCase()}
                    </Text>
                )}
            </View>

            <View style={{ flex: 1 }}>
                <TeamProgressView title='CONTENIDO VISTO' progress={region.watched_content ?? 0} color={colorFilled} />
                <TeamProgressView title='ÍNDICE SALESBOOK' progress={region.knowledge ?? 0} color={theme.colors.colorApproved} />
                <TeamProgressView title='CAPACIDAD TEÓRICA' progress={region.knowledge_technical ?? 0} color={theme.colors.colorInProgress} />
                <TeamProgressView title='CAPACIDAD PRÁCTICA' progress={region.knowledge_practical ?? 0} color={theme.colors.colorSecondary} />
            </View>
        </TouchableOpacity>
    )
}

export const RegionItemSingle = ({
    region,
    onClickRegion,
    card,
}: {
    region: AdvanceTeamRegion
    onClickRegion: (region: AdvanceTeamRegion) => void
    card: boolean
}) => {
    const isMobile = useIsMobile()
    return (
        <TouchableOpacity
            style={[
                card ? styles.containerRowCard : [styles.containerRow, styles.padding],
                { pointerEvents: !card ? 'none' : null, justifyContent: 'space-between', backgroundColor: theme.colors.filtersBackground },
                !isMobile && { borderRadius: 12 },
            ]}
            onPress={() => onClickRegion(region)}
        >
            <View style={[styles.marginHorizontal, { justifyContent: 'center' }]}>
                {region.name && <Text style={[styles.region, !isMobile && { fontSize: 16 }]}>Región</Text>}
                {region.name && <View style={styles.spacer1}></View>}
                {region.name && <Text style={[styles.section, !isMobile && { fontSize: 16 }]}>{region.name.toUpperCase()}</Text>}
            </View>
            <View>
                <View style={[styles.marginHorizontal, { justifyContent: 'center', alignItems: 'center' }]}>
                    <Progress.Circle
                        size={60}
                        progress={0.3}
                        showsText={false}
                        textStyle={styles.percentage}
                        thickness={6}
                        color={theme.colors.colorPrimary}
                        unfilledColor={'white'}
                        borderWidth={0}
                        strokeCap='round'
                        style={{ alignSelf: 'center' }}
                    />
                    {region.ranking && <Text style={[styles.percentageBis, styles.alignCenter, { position: 'absolute' }]}>{region.ranking}°</Text>}
                </View>
            </View>
        </TouchableOpacity>
    )
}

export const TeamItem = ({
    team,
    onClickTeam,
    numColumns,
}: {
    team: AdvanceTeamModel
    onClickTeam: (team: AdvanceTeamModel) => void
    numColumns: number
}) => {
    const isMobile = useIsMobile()
    const maxWidth = numColumns > 2 ? '33%' : '50%'
    return (
        <TouchableOpacity style={[styles.card, !isMobile && { maxWidth: maxWidth }]} onPress={() => onClickTeam(team)}>
            <View style={styles.headerCard}>
                <Image source={{ uri: avatarPlaceholder }} style={styles.avatar} />
                <View style={styles.marginHorizontal}>
                    <Text style={[styles.titleSection, !isMobile && { fontSize: 16 }]}>{team.level}</Text>
                    <View style={styles.spacerText}></View>
                    <Text style={[styles.subtitleSection, !isMobile && { fontSize: 16 }]}>{team.name}</Text>
                    <View style={styles.spacerText}></View>
                    <Text style={[styles.descriptionSection, !isMobile && { fontSize: 16 }]}>{team.role}</Text>
                </View>
            </View>
            <View style={[styles.paddingBottom, !isMobile && { marginTop: 12 }]}>
                <TeamProgressView title='CONTENIDO VISTO' progress={team.watched_content ?? 0} color={colorFilled} />
                <TeamProgressView title='ÍNDICE SALESBOOK' progress={team.knowledge ?? 0} color={theme.colors.colorApproved} />
                <TeamProgressView title='CAPACIDAD TEÓRICA' progress={team.knowledge_technical ?? 0} color={theme.colors.colorInProgress} />
                <TeamProgressView title='CAPACIDAD PRÁCTICA' progress={team.knowledge_practical ?? 0} color={theme.colors.colorSecondary} />
            </View>
        </TouchableOpacity>
    )
}

export const TeamProgressView = ({ title, progress, color }) => {
    const isMobile = useIsMobile()
    const progressHeight = isMobile ? 12 : 6
    return (
        <View style={styles.containerProgress}>
            <View style={{ flex: 1 }}>
                <Text style={[styles.subtitleModule, !isMobile && { fontSize: 16 }]}>{title}</Text>
                <View style={styles.spacer1}></View>
                <View style={{ flex: 1 }}>
                    <Progress.Bar
                        progress={progress / 100}
                        height={progressHeight}
                        width={null}
                        style={[styles.progressBar]}
                        borderWidth={0}
                        color={color}
                        unfilledColor={theme.colors.lightGray}
                    />
                </View>
                <View style={styles.spacer1}></View>
                <View style={styles.spacer1}></View>
                <View style={styles.spacer1}></View>
            </View>
        </View>
    )
}
